import { getCalApi } from '@calcom/embed-react';
import { useEffect } from 'react';

import type { BookingDetails } from '@/components/common/CalendarPopupButton';
import settings from '@/constants/constants';
import { removeChildElements } from '@montugroup/frontend-common';

interface IFormData {
  name?: string;
  email?: string;
  phoneNumber?: string;
}

interface UseCalendarPopupButtonProps {
  formData?: IFormData;
  onOpen?: () => void;
  handleBookingSuccess?: (value?: BookingDetails) => void;
  handleRescheduleSuccess?: (value?: BookingDetails) => void;
  handleCancelSuccess?: (value?: BookingDetails) => void;
  theme: 'dark' | 'light';
}

function useCalendarBooking({
  formData,
  onOpen,
  handleBookingSuccess,
  handleRescheduleSuccess,
  handleCancelSuccess,
  theme,
}: UseCalendarPopupButtonProps) {
  useEffect(() => {
    (async function initCalendar() {
      const cal = await getCalApi(settings.calendarConfig.embedJsUrl);

      cal('ui', {
        theme,
      });

      if (handleBookingSuccess) {
        cal('on', {
          action: 'bookingSuccessful',
          callback: ({ detail }) => {
            handleBookingSuccess(detail.data as BookingDetails);

            removeChildElements('cal-modal-box');
            document.body.removeAttribute('style'); // this removes overflow hidden style applied by Calcom
          },
        });
      }

      if (handleRescheduleSuccess) {
        cal('on', {
          action: 'rescheduleBookingSuccessful',
          callback: ({ detail }) => {
            handleRescheduleSuccess(detail.data as BookingDetails);

            removeChildElements('cal-modal-box');
            document.body.removeAttribute('style'); // this removes overflow hidden style applied by Calcom
          },
        });
      }

      if (handleCancelSuccess) {
        cal('on', {
          action: 'bookingCancelled',
          callback: ({ detail }) => {
            handleCancelSuccess(detail.data as BookingDetails);

            removeChildElements('cal-modal-box');
            document.body.removeAttribute('style'); // this removes overflow hidden style applied by Calcom
          },
        });
      }

      if (typeof onOpen === 'function') {
        cal('on', { action: 'linkReady', callback: onOpen });
      }
    })();
  }, [onOpen, handleBookingSuccess, handleRescheduleSuccess, handleCancelSuccess, theme]);

  return {
    formData: formData ? JSON.stringify(formData) : undefined,
    origin: settings.calendarConfig.calOrigin,
  };
}

export default useCalendarBooking;
